"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapToState = mapToState;
// takes a promise and maps its state to the given component
// takes component and promise as function to ensure accurate state and promise handling
function mapToState(component, promise) {
    // set initial loading state
    var currentState = component().state;
    currentState.isLoading = true;
    currentState.error = null;
    component().setState(currentState);
    currentState.dismissError = function () {
        return;
    };
    // launch promise
    return promise().then(function (value) {
        var currentState = component().state;
        currentState.isLoading = false;
        component().setState(currentState);
        return value;
    }).catch(function (error) {
        var currentState = component().state;
        currentState.isLoading = false;
        currentState.error = error;
        // set dismissError handler which removes error and handler
        currentState.dismissError = function () {
            var currentState = component().state;
            currentState.error = null;
            currentState.dismissError = function () {
                return;
            };
            component().setState(currentState);
        };
        component().setState(currentState);
        // rethrow error for subscribers
        throw error;
    });
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/mapToState.tsx
 ** module id = 101
 ** module chunks = 0
 **/